var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('am-card-header',{staticClass:"am-accordion-item-header",on:{"click":_vm.toggle}},[_vm._t("title"),_c('am-icon-button',{attrs:{"slot":"actions","icon":_vm.isOpen ? 'close' : 'expand_more'},slot:"actions"})],2),_c('am-card-body',{class:{ 'am-accordion-item--closed': !_vm.isOpen }},[_vm._t("content")],2),_c('am-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }